import request from '@/utils/request'

let MaterialApi = {
  /*素材列表*/
  materialList(data, errorback) {
    return request._post('/shop/plus.material4.material/index', data, errorback);
  },
  /*添加素材*/
  toAddMaterial(data, errorback) {
    return request._get('/shop/plus.material4.material/add', data, errorback);
  },
  /*素材添加*/
  materialAdd(data, errorback) {
    return request._post('/shop/plus.material4.material/add', data, errorback);
  },
  /*编辑素材*/
  toEditMaterial(data, errorback) {
    return request._get('/shop/plus.material4.material/edit', data, errorback);
  },
  /*素材编辑*/
  materialEdit(data, errorback) {
    return request._post('/shop/plus.material4.material/edit', data, errorback);
  },
  /*素材删除*/
  materialDel(data, errorback) {
    return request._post('/shop/plus.material4.material/delete', data, errorback);
  },
  /*获取素材分类*/
  getCategory(data, errorback) {
    return request._post('/shop/plus.material4.category/index', data, errorback);
  },
  /*添加分类*/
  addCategiry(data, errorback) {
    return request._post('/shop/plus.material4.category/add', data, errorback);
  },
  /*编辑分类*/
  editCategory(data, errorback) {
    return request._post('/shop/plus.material4.category/edit', data, errorback);
  },
  /*删除分类*/
  deleteCategory(data, errorback) {
    return request._post('/shop/plus.material4.category/delete', data, errorback);
  },
}
export default MaterialApi;



// WEBPACK FOOTER //
// ./src/api/material4.js